import { Injectable } from '@angular/core';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { AnalyticsApi, RefrigerationCircuitMessagesData } from '@vi-iot/client';

import { InstallationDetailsStore, RefrigerationCircuitMessagesActions } from '@store';

@Injectable()
export class RefrigerationCircuitMessagesEffects {
  getRefrigerationCircuitMessages$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(RefrigerationCircuitMessagesActions.getRefrigerationCircuitMessages),
      concatLatestFrom(() => this.installationDetailsStore.gatewaySerial$),
      switchMap(([_action, gatewaySerial]) =>
        this.analyticsApi.getRefrigerationCircuitMessages({ gateway_id: gatewaySerial }).pipe(
          map((response: { data: RefrigerationCircuitMessagesData[] }) =>
            RefrigerationCircuitMessagesActions.getRefrigerationCircuitMessagesSuccess({
              messages: response.data,
            })
          ),
          catchError((error) =>
            of(RefrigerationCircuitMessagesActions.getRefrigerationCircuitMessagesError({ error }))
          )
        )
      )
    );
  });

  constructor(
    private actions$: Actions,
    private analyticsApi: AnalyticsApi,
    private installationDetailsStore: InstallationDetailsStore
  ) {}
}
